<script>
  import Vue from 'vue'
  import api from '../api'
  import Vuetable from 'vuetable-2/src/components/Vuetable'
  import BulmaPagination from '../components/BulmaPagination'
  import FilterBar from '../components/FilterBar'
  import AddressCard from '../components/AddressCard'
  import swal from 'sweetalert'
  import qs from 'query-string'
  import { mapState } from 'vuex'

  export default {
    created () {
      this.fetchAddresses()
    },

    data () {
      return {
        addresses: [],
        search: '',
        page: 1
      }
    },

    components: {
      Vuetable,
      BulmaPagination,
      FilterBar,
      AddressCard
    },

    methods: {
      onChangePage(page) {
        this.page = page

        this.fetchAddresses()
      },

      doSearch() {
        this.page = 1

        this.fetchAddresses()
      },

      async fetchAddresses () {
        let params = {
          filter: this.search,
          page: this.page,
          per_page: 9
        }
        let addresses = await api.apios.get('/api/addresses?' + qs.stringify(params))

        this.$refs.pagination.setPaginationData(addresses.data)
        this.addresses = addresses.data.data
      }
    },

    computed: {
      ...mapState(['user'])
    }
  }
</script>
<style>
  .search {
    width: 300px;
  }
</style>
<template>
  <section class="section">
    <div class="container">
      <h1 class="title">Addresses</h1>
      <hr />

      <div class="field is-grouped">
        <p class="control is-expanded has-addons">
          <input type="text" v-model="search" class="input search" @keyup.enter="doSearch" placeholder="Search...">
          <a @click="doSearch" class="button is-primary">Go</a>
        </p>

        <router-link v-if="user.gates['addresses.create']" to="/addresses/create" class="button is-primary">
          <span class="icon is-small">
            <i class="fa fa-plus"></i>
          </span>
          <span>New Address</span>
        </router-link>
      </div>
      
      <div class="columns is-multiline">
        <div class="column is-one-third" v-for="address in addresses">
          <address-card @refresh="fetchAddresses" :address="address"></address-card>
        </div>
      </div>

      <bulma-pagination ref="pagination" @vuetable-pagination:change-page="onChangePage"></bulma-pagination>
    </div>
  </section>
</template>